<template>
  <div>
    <FastTrackAgreementRenderer
      v-for="agreement in agreements"
      :key="agreement.id"
      :agreement="agreement"
      :value="value ? value : {}"
      @input="$event => updateValue({ agreement, payload: $event })"
    />
  </div>
</template>

<script>
// @ts-check
import webcall from '@/libs/webcall';
import { Agreement } from '@/classes/agreement';
import FastTrackAgreementRenderer from './AppAdditionalAgreementsFastTrack/FastTrackAgreementRenderer';

/**
 * @typedef {Record<string, Record<string, string[]>>} AdditionalAgreementsValue
 */
/**
 * @type {() => AdditionalAgreementsValue}
 */
const AdditionalAgreementsValueType = Object;

export default {
  components: {
    FastTrackAgreementRenderer,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
    value: {
      type: AdditionalAgreementsValueType,
      required: true,
    },
  },

  data() {
    return {
      error: null,
      isLoading: false,
      agreements: [],
    };
  },

  mounted() {
    this.fetchAdditionalAgreements();
  },

  methods: {
    /**
     * @param {{
     *   agreement: Agreement;
     *   payload: Record<string, string[]>
     * }} data
     *
     * @fires #input
     */
    updateValue(data) {
      const { agreement, payload } = data;
      const eventPayload = { ...this.value, [agreement.code]: { ...payload } };
      /**
       * @event #input
       * @type {AdditionalAgreementsValue}
       */
      this.$emit('input', eventPayload);
    },

    fetchAdditionalAgreements() {
      this.isLoading = true;
      this.error = null;

      webcall.submission.fastTrackAdditionalAgreements()
        .then(({ data }) => {
          this.agreements = data.agreements.map(agreement => new Agreement(agreement));
          this.isLoading = false;
        })
        .catch((error) => {
          this.error = error;
          this.isLoading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreementsFastTrack.vue